export default {"src":"/_next/static/media/HipFracturesjkh.1378a76a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};